import { Slide } from "@jelly/lesson";
import config from "appConfig";

import { task as task03 } from "../../../../../task/course-03/lesson-04/task-03";

const task: Slide = {
  description: "What kind of function has a Fourier Transform like?",
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [5, 1],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/03/04/task/task-3.svg`,
                },
              },
              styles: {
                padding: "10% 0 2%",
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task03.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
